import React from 'react'
import { Icon } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import './SuperCutoff.css'

// Mappa stato → icona Semantic UI
const STATUS_ICON = {
  pending: 'circle outline',
  in_progress: 'spinner',
  completed: 'check circle',
  error: 'times circle',
}

const STATUS_COLOR = {
  pending: '#aaa',
  in_progress: '#4a7fe5',
  completed: '#21ba45',
  error: '#db2828',
}

// Mappa stato → etichetta visibile all'utente
const STATUS_LABEL = {
  pending: 'pending',
  in_progress: 'in progress',
  completed: 'completed',
  error: 'error',
}

const STATI_VALIDI = Object.keys(STATUS_ICON)

/**
 * Wrapper presentazionale per un singolo step del wizard SuperCutoff.
 * Mostra header con numero, titolo, stato e il contenuto specifico dello step.
 *
 * Props:
 *   stepNumber  {number}    Numero progressivo dello step (1-based)
 *   title       {string}    Titolo dello step
 *   status      {string}    Stato: 'pending' | 'in_progress' | 'completed' | 'error'
 *   children    {node}      Contenuto specifico dello step
 */
const SuperCutoffStep = ({ stepNumber, title, status, children }) => {
  if (process.env.NODE_ENV === 'development' && !STATI_VALIDI.includes(status)) {
    console.warn(
      'SuperCutoffStep: valore di status non riconosciuto "' + status + '". ' +
      'Valori attesi: ' + STATI_VALIDI.join(', ') + '. Verrà usato il fallback "pending".'
    )
  }

  const icon = STATUS_ICON[status] || STATUS_ICON.pending
  const color = STATUS_COLOR[status] || STATUS_COLOR.pending
  const label = STATUS_LABEL[status] || STATUS_LABEL.pending

  // color è un valore calcolato a runtime da STATUS_COLOR — non esprimibile come classe CSS
  const statusIconStyle = { color, margin: 0 }
  const statusLabelStyle = { color }

  const headingId = 'supercutoff-step-title-' + stepNumber

  return (
    <div className="supercutoff-step-panel" aria-labelledby={headingId}>
      <div className="supercutoff-step-panel-header">
        <span className="step-badge">Step {stepNumber}</span>
        <h3 id={headingId}>{title}</h3>
        <div
          className="supercutoff-step-status"
          role="status"
          aria-live="polite"
        >
          <Icon name={icon} aria-hidden="true" style={statusIconStyle} />
          <span className="supercutoff-step-status-label" style={statusLabelStyle}>
            {label}
          </span>
        </div>
      </div>
      <div className="supercutoff-step-panel-body">
        {children}
      </div>
    </div>
  )
}

SuperCutoffStep.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['pending', 'in_progress', 'completed', 'error']).isRequired,
  children: PropTypes.node.isRequired,
}

export default SuperCutoffStep
